import { createSlice } from "@reduxjs/toolkit";
import { loadState } from "../LocalStorage/LocalStorage";

export const initialUserState = loadState("user", {
    access_token: "",
    user: "",
    registrationFormUrl: ""
})

const UserSlice = createSlice({
    name: "Users",
    initialState: initialUserState,

    reducers: {

        setUser(state, action) {
            const user = action.payload
            state.user = user || {}
        },
        setAccessToken(state, action) {
            const access_token = action.payload
            state.access_token = access_token || ""
        },

        setBusinessToken(state, action) {
            const business_token = action.payload
            state.business_token = business_token || ""
        },
        setInstitueLogo(state, action) {
            const institue_logo = action.payload
            state.institue_logo = institue_logo || ""
        },
        setHeaderLogo(state, action) {
            const header_logo = action.payload
            state.header_logo = header_logo || ""
        },
        setHeaderName(state, action) {
            const header_name = action.payload
            state.header_name = header_name || ""
        },

        setRegisterData(state, action) {
            const registerData = action.payload
            state.registerData = registerData || {}
        },

        setFooterData(state, action) {
            const footerdata = action.payload
            state.footerdata = footerdata || {}
        },

         setUtilities(state, action) {
            const utilities = action.payload
            state.utilities = utilities || {}
        },
        setRegistrationFormUrl(state, action) {
            const registrationFormUrl = action.payload
            state.registrationFormUrl = registrationFormUrl || ""
        },


    }
})

export const { setUser, setAccessToken, setBusinessToken, setRegisterData, setFooterData, setUtilities, setInstitueLogo, setRegistrationFormUrl, setHeaderLogo, setHeaderName } = UserSlice.actions;

export default UserSlice;